import { useQueryClient } from '@tanstack/react-query'

import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGame from '@/modules/game/api/hooks/useMutationUpdateGame'
import { GameQueryKeys } from '@/modules/game/keys'

import type { GetGameListTableData } from '@/modules/game/type'

interface IsNewGameProps {
	row: GetGameListTableData
}

export function IsNewGame({ row }: IsNewGameProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGame } = useMutationUpdateGame()

	const handleMutate = async (value: boolean) => {
		await updateGame({
			id: row.id,
			payload: {
				isNew: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isNew}
			onMutate={handleMutate}
			successMessage="อัพเดทเกมใหม่สำเร็จ"
		/>
	)
}
